import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { IFilterView } from '@ncg/data';
import SwiperCore, { Lazy, Navigation } from 'swiper';
import { SwiperComponent } from 'swiper/angular';

SwiperCore.use([Lazy, Navigation]);

@Component({
    selector: 'ncg-product-item-carousel',
    template: `
        <div class="container product-item-carousel">
            <swiper
                #swiper
                [slidesPerView]="'auto'"
                [spaceBetween]="0"
                [navigation]="true"
                [simulateTouch]="false"
                [preloadImages]="false"
                [lazy]="true"
            >
                <ng-template swiperSlide *ngFor="let picture of limitedPictures; let isLast = last; let isFirst = first">
                    <a [routerLink]="[productUrl]" class="product-item-carousel__link">
                        <div class="is-ratio-product-item">
                            <ng-container *ngIf="view === 'grid'">
                                <img
                                    *ngIf="isFirst"
                                    [src]="picture | productImage: 'small'"
                                    srcset="{{ picture | productImage: 'small' }} 400w, {{ picture | productImage: 'medium' }} 800w"
                                    sizes="100vw"
                                    loading="lazy"
                                    width="400"
                                    height="267"
                                    ncgImageLoad
                                />
                                <img
                                    *ngIf="!isFirst"
                                    [attr.data-src]="picture | productImage: 'medium'"
                                    class="swiper-lazy"
                                    width="400"
                                    height="267"
                                />
                            </ng-container>
                            <ng-container *ngIf="view !== 'grid'">
                                <img *ngIf="isFirst" [src]="picture | productImage: 'small'" loading="lazy" width="400" height="267" ncgImageLoad />
                                <img
                                    *ngIf="!isFirst"
                                    [attr.data-src]="picture | productImage: 'small'"
                                    class="swiper-lazy"
                                    width="400"
                                    height="267"
                                />
                            </ng-container>
                            <div *ngIf="!isFirst" class="swiper-lazy-preloader"></div>
                            <div class="product-item-carousel__more" *ngIf="isLast && totalAmountSlides > maxSlideToShow">
                                {{ 'product_item.see_all_images' | translate: { number: totalAmountSlides } }}
                            </div>
                        </div>
                    </a>
                </ng-template>
            </swiper>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductItemCarouselComponent implements OnChanges {
    @ViewChild('swiper') swiper: SwiperComponent;
    @Input() itemId: string;
    @Input() productUrl: string;
    @Input() pictures: string[];
    @Input() view?: IFilterView;
    get limitedPictures(): string[] {
        this.totalAmountSlides = this.pictures.length;
        return this.pictures.slice(0, this.maxSlideToShow);
    }
    maxSlideToShow = 5;
    totalAmountSlides = 0;

    ngOnChanges(changes: SimpleChanges) {
        if (changes?.view?.currentValue !== changes?.view?.previousValue && this.swiper?.swiperRef) {
            this.swiper.swiperRef.update();
        }
    }
}
